// Module
var code = "<div data-moduleicon=\"fpd-icon-name-number\" data-defaulttext=\"Names & Numbers\" data-title=\"modules.names_numbers\"> <div class=\"fpd-head\"> <span class=\"fpd-btn\" data-defaulttext=\"Add New\">modules.names_numbers_add_new</span> </div> <div class=\"fpd-scroll-area\"> <div class=\"fpd-list\"></div> </div> </div>";
// Exports
module.exports = code;